export const env = process.env.NODE_ENV === 'development';
const devUrl = 'http://192.168.2.38:23000'
// const devUrl = 'http://192.168.2.71:8081'
// const devUrl = 'http://kinpoway.top:60000'
const proUrl = window.location.origin
// export const flvVideoSrc='http://36.136.118.131:18080'

//本地调试
// export const baseUrl = 'http://192.168.2.35:23000'  //192.168.8.110:9012  http://1.14.147.139:12001  http://192.168.2.35:23000  http://kinpoway.top:60000
// export const imageBaseUrl = 'http://192.168.2.35:23000/uploadfiles/'
// // //地图瓦片图服务地址
// export const mapSrverUrl = 'http://192.168.2.35:23000'
// export const fileUrl = 'http://192.168.2.35:23000'


// 试运行  http://kinpoway.top:60000
// export const baseUrl = window.location.origin
// export const imageBaseUrl = window.location.origin + '/uploadfiles/'
// //地图瓦片图服务地址
// export const mapSrverUrl = window.location.origin
// export const fileUrl = window.location.origin

export const baseUrl = env ? devUrl : proUrl
export const imageBaseUrl = `${baseUrl}/uploadfiles/`
//地图瓦片图服务地址
export const mapSrverUrl = baseUrl
export const fileUrl = baseUrl
// console.log(baseUrl);












// WEBPACK FOOTER //
// ./src/config/env.js